import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Enter a valid email address");
      return;
    }
    setLoading(true);
    try {
      await api.newsletter(email);
      setDone(true);
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="border-t border-wire bg-obsidian noise-overlay" data-testid="newsletter-section">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-20 sm:py-28">
        <div className="max-w-2xl">
          <p className="font-mono text-[10px] tracking-[0.35em] text-neutral-500">FIRST ACCESS</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight text-white">
            Drops sell out. <span className="text-neutral-500">The list doesn't miss.</span>
          </h2>
          {done ? (
            <p data-testid="newsletter-success" className="mt-8 border border-wire px-6 py-5 font-mono text-xs tracking-[0.25em] text-neutral-300">
              YOU'RE ON THE LIST. WELCOME TO THE OUTFIT.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-8 flex flex-col gap-3 sm:flex-row">
              <input
                data-testid="newsletter-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="EMAIL ADDRESS"
                className="flex-1 border border-wire bg-transparent px-5 py-4 font-mono text-xs tracking-[0.2em] text-white placeholder:text-neutral-600 focus:border-white focus:outline-none"
              />
              <button
                data-testid="newsletter-subscribe-button"
                disabled={loading}
                className="flex items-center justify-center gap-3 bg-white px-8 py-4 font-mono text-[11px] tracking-[0.35em] text-black transition-colors hover:bg-neutral-300 disabled:opacity-50"
              >
                {loading ? "JOINING..." : "JOIN"} <ArrowRight size={13} />
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
